import { render, staticRenderFns } from "./ImageParagraph.vue?vue&type=template&id=09f5a4d3"
import script from "./ImageParagraph.vue?vue&type=script&lang=js"
export * from "./ImageParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports